import { createContext, useContext, useEffect } from 'react';

export type Miga = { texto: string; a?: string };

type Ctx = { migas: Miga[]; setMigas: (m: Miga[]) => void };

export const MigasContext = createContext<Ctx>({ migas: [], setMigas: () => {} });

export const useMigasContexto = () => useContext(MigasContext);

/**
 * Cada página fija sus migas de pan y el Shell las pinta en el encabezado.
 *
 * Se limpian al desmontar: si no, al navegar a una pantalla que no las declara
 * quedarían las de la anterior, señalando un lugar donde ya no estás.
 */
export function useMigas(items: Miga[]) {
  const { setMigas } = useMigasContexto();
  // Se compara el contenido y no la referencia: un arreglo literal en el cuerpo
  // del componente es nuevo en cada render y dispararía el efecto sin parar.
  const clave = JSON.stringify(items);

  useEffect(() => {
    setMigas(JSON.parse(clave) as Miga[]);
    return () => setMigas([]);
  }, [clave, setMigas]);
}
